/**
 * 도메인 간 언어 설정 공유를 위한 쿠키 기반 저장소
 * - naegift.com 도메인: domain=.naegift.com 쿠키로 shopadmin/www/shopuser 간 공유
 * - localhost: localStorage 사용 (쿠키 domain 제한)
 * - 기존 localStorage 사용자: 쿠키 없을 때 localStorage 값 읽어 마이그레이션
 */

const COOKIE_NAME = 'language';
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1년

function getCookieDomain(): string | null {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname;
  if (host.includes('naegift.com')) return '.naegift.com';
  return null;
}

function getCookieValue(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp('(^| )' + COOKIE_NAME + '=([^;]+)')
  );
  return match ? match[2] : null;
}

/**
 * 저장된 언어 반환 (쿠키 우선 → localStorage → 'ko')
 */
export function getLanguage(): 'ko' | 'en' {
  if (typeof window === 'undefined') return 'ko';

  const cookieVal = getCookieValue();
  if (cookieVal === 'ko' || cookieVal === 'en') return cookieVal;

  const localVal = localStorage.getItem(COOKIE_NAME);
  if (localVal === 'ko' || localVal === 'en') {
    // 마이그레이션: localStorage → 쿠키 동기화
    const domain = getCookieDomain();
    if (domain) {
      document.cookie = `${COOKIE_NAME}=${localVal}; path=/; domain=${domain}; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
    }
    return localVal;
  }

  return 'ko';
}

/**
 * 언어 저장 (쿠키 + localStorage)
 */
export function setLanguage(lang: string): void {
  if (typeof window === 'undefined') return;
  const valid = lang === 'ko' || lang === 'en';
  const value = valid ? lang : 'ko';

  const domain = getCookieDomain();
  if (domain) {
    document.cookie = `${COOKIE_NAME}=${value}; path=/; domain=${domain}; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  }
  localStorage.setItem(COOKIE_NAME, value);
}
